<ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-step-header [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-header>
  </ng-template>
  <ng-template #content>
    <div class="d-flex h-100">
      <!-- Left Column -->
      <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
        <div class="text-center mb-4 pt-m">
          <app-headline [title]="'CALADDEVENT' | translate" [type]="'h5'"></app-headline>
        </div>
        <app-step-content [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-content>
        <div class="save-button-container text-center mt-3 d-none d-md-block">
          <app-form-button [text]="'SAVE' | translate" [disabled]="calendarEventForm.invalid || inventoryForm.invalid || !canSaveCurrentEvent()" (click)="save()" [cssClass]="'e-primary w-100'"></app-form-button>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="steps[activeStep].title" [type]="'h5'"></app-headline>
            <div class="ms-2">
              @if (steps[activeStep]?.help; as help) {
                <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="help" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
              }
            </div>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close'"></app-form-button>
        </div>

        <div class="custom-scrollbar overflow-y-auto">
          <form class="p-1 d-flex flex-column h-100">
            @switch(steps[activeStep]?.id) {
              @case('details') {
                <app-form-label [label]="'CALENDAR' | translate"></app-form-label>
                <div class="mb-3">
                  @if (canEditCalendarSelection) {
                  <app-form-dropdown
                    [fG]="calendarEventForm"
                    [fCN]="'calendar_id'"
                    [dataSource]="availableCalendars()"
                    [placeholder]="'SELECT' | translate"
                    [disabled]="!canEditCalendarSelection"
                  ></app-form-dropdown>
                  } @else {
                    <app-form-input
                      [placeholder]="('CALENDAR' | translate)"
                      [fCN]="'calendar_name_display'"
                      [fG]="calendarEventForm"
                      [disabled]="true"
                    ></app-form-input>
                  }
                </div>
                <app-form-label 
                  [label]="'CALEVENTNAME' | translate" 
                  [maxChars]="255" 
                  [currentChars]="calendarEventForm.controls['name'].value.length"
                  >
                  </app-form-label>
                <app-form-input 
                  [placeholder]="('CALEVENTNAME' | translate)" 
                  [label]="('CALEVENTNAME' | translate)" 
                  [errorText]="getNameErrorText()" 
                  [fCN]="'name'" 
                  [fG]="calendarEventForm" 
                  [maxChars]="255"
                  >
                  </app-form-input>
                <app-form-label [label]="'CALPRIORITYLEVEL' | translate"></app-form-label>
                <div class="mb-3">
                  <app-form-dropdown 
                    [fG]="calendarEventForm" 
                    [fCN]="'priority'" 
                    [dataSource]="priorityOptions" 
                    [placeholder]="'SELECT' | translate" 
                    [marker]="'priority'"
                    >
                    </app-form-dropdown>
                </div>
                <app-form-label [label]="'CALEVENTDESCRIPTION' | translate" [maxChars]="65535" [currentChars]="(calendarEventForm.controls['description'].value ?? '').length"></app-form-label>
                <div class="mb-3">
                  <app-form-textarea 
                    [placeholder]="('CALEVENTDESCRIPTION' | translate)" 
                    [errorText]="getDescriptionErrorText()"
                    [fCN]="'description'" 
                    [fG]="calendarEventForm" 
                    [maxChars]="65535" 
                    [rows]="4" 
                    [enableRichTextResize]="true" 
                    [richText]="true"
                    >
                  </app-form-textarea>
                </div>
                <app-form-label [label]="'CALEVENTLOCATIONLABEL' | translate"></app-form-label>
                <div class="mb-3 d-flex gap-2">
                  <app-form-radio 
                      [fG]="calendarEventForm" 
                      [fCN]="'enableCustomLocation'" 
                      [name]="'enableCustomLocationtfalse'" 
                      [value]="false" 
                      [placeholder]="'CALNOCUSTOMLOCATION' | translate" 
                      [cssClass]="'e-normal'"
                      >
                    </app-form-radio>
                    <app-form-radio 
                      [fG]="calendarEventForm" 
                      [fCN]="'enableCustomLocation'" 
                      [name]="'enableCustomLocationtrue'" 
                      [value]="true" 
                      [placeholder]="'CALUSECUSTOMLOCATION' | translate" 
                      [cssClass]="'e-normal'"
                      >
                    </app-form-radio>
                    
                  </div>
                  @if(calendarEventForm.controls['enableCustomLocation'].value){
                    <div class="mb-3">
                      <app-form-label [maxChars]="250" [currentChars]="calendarEventForm.controls['location'].value.length"></app-form-label>
                      <app-form-textarea 
                        [placeholder]="('CALEVENTLOCATION' | translate)" 
                        [errorText]="getLocationErrorText()"
                        [fCN]="'location'" 
                        [fG]="calendarEventForm" 
                        [maxChars]="250" 
                        [rows]="4"
                        >
                      </app-form-textarea>
                    </div>
                  }
                <app-form-label [label]="'CALEVENTATTACHMENTS' | translate"></app-form-label>
                <div class="mb-3">
                  <app-dialog-documents-upload
                    [view]="'component'"
                    [files]="attachmentFiles"
                    (filesChange)="onAttachmentFilesChange($event)"
                    [multiple]="true"
                    [type]="'both'"
                    [hideMyFilesOption]="true"
                  ></app-dialog-documents-upload>
                </div>
              }
              @case('date') {
                <div class="row">
                  <!-- Start Date -->
                  <div class="col-12 col-md-6 mb-3">
                    <app-form-label [label]="'CALEVENTSTARTDATE' | translate"></app-form-label>
                    @if(calendarEventForm.get('isWholeday')?.value) {
                      <app-form-date
                        [fG]="calendarEventForm"
                        [fCN]="'onDateStart'"
                        [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                      ></app-form-date>
                    } @else {
                      <app-form-date-time
                        [fG]="calendarEventForm"
                        [fCN]="'onDateStart'"
                        [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                        [step]="calendarStepMinutes"
                      ></app-form-date-time>
                    }
                  </div>
    
                  <!-- End Date-->
                  <div class="col-12 col-md-6 mb-3">
                    <app-form-label [label]="'CALEVENTENDDATE' | translate"></app-form-label>
                    @if(calendarEventForm.get('isWholeday')?.value){
                      <app-form-date
                        [fG]="calendarEventForm"
                        [fCN]="'onDateEnd'"
                        [placeholder]="'CALEVENSELECTENDDATE' | translate"
                      ></app-form-date>
                    } @else {
                      <app-form-date-time
                        [fG]="calendarEventForm"
                        [fCN]="'onDateEnd'"
                        [placeholder]="'CALEVENSELECTENDDATE' | translate"
                        [step]="calendarStepMinutes"
                      ></app-form-date-time>
                    }
                  </div>
                </div>
    
                <!-- Whole day and Timezone-->
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <div class="d-flex flex-wrap gap-3">
                      <app-form-checkbox
                        [fCN]="'isWholeday'"
                        [fG]="calendarEventForm"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'CALLALLDAYEVENT' | translate"
                      ></app-form-checkbox>
                    </div>
                  </div>
                </div>
    
                <!-- Timezone  -->
                  <div class="row"> 
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'STARTTIMEZONE' | translate"></app-form-label>
                      <app-form-dropdown
                        [fG]="calendarEventForm"
                        [fCN]="'startTimeZone'"
                        [dataSource]="customTimezone"
                        [placeholder]="'SELECT' | translate"
                        [allowFiltering]="true"
                        [mapping]="{text: 'name', value: 'id'}"
                        (search)="timezoneSearch($event)"
                      ></app-form-dropdown>
                    </div>
                  </div>

                  <!-- Notification selection -->
                  <div class="row"> 
                    <div class="col-12 mb-3">
                      <app-form-label [label]="'CALENDARNOTIFYGUESTSTITLE' | translate"></app-form-label>
                      <div class="d-flex flex-column gap-2">
                        <div class="d-flex flex-wrap align-items-center gap-3">
                          <app-form-radio
                            [fG]="calendarEventForm"
                            [fCN]="'shouldNotify'"
                            [name]="'calendar-event-notify'"
                            [value]="true"
                            [placeholder]="'CALENDARNOTIFYGUESTS' | translate"
                            [cssClass]="'e-normal'"
                          ></app-form-radio>
                          <app-form-radio
                            [fG]="calendarEventForm"
                            [fCN]="'shouldNotify'"
                            [name]="'calendar-event-notify'"
                            [value]="false"
                            [placeholder]="'CALENDARDONTNOTIFYGUESTS' | translate"
                            [cssClass]="'e-normal'"
                          ></app-form-radio>
                        </div>
                        @if(calendarEventForm.get('shouldNotify')?.value) {
                          <div class="col-12 col-md-6">
                            <div class="d-flex flex-column gap-2">
                              @if(calendarEventForm.get('isWholeday')?.value === false){
                                <app-form-label [label]="'CALEVENTNOTIFYBEFOREMINUTES' | translate"></app-form-label>
                                <app-form-numeric [fG]="calendarEventForm" [fCN]="'notifyBeforeMinutes'"></app-form-numeric>
                              } @else {
                                <app-form-label [label]="'CALEVENTNOTIFYAT' | translate"></app-form-label>
                                <app-form-time 
                                  [placeholder]="'SELECTTIME' | translate"
                                  [fG]="calendarEventForm"
                                  [fCN]="'notifyAt'"
                                  >
                                </app-form-time>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
    
                @if(!isOverrideEvent) {
                <!-- BASE REPEAT -->
                  <div class="row">
                    <!-- Repeat -->
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATS' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatType'" [dataSource]="repeatTypeOptions" [placeholder]="'SELECT' | translate" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
      
                    <!-- Repeats Every-->
                    <div class="col-12 col-md-6 mb-3" [class.d-none]="calendarEventForm.get('repeatType')?.value === 'never'">
                      <app-form-label [label]="'CALEVENTREPEATSEVERY' | translate"></app-form-label>
                      <div class="d-flex align-items-center gap-1">
                        <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatEvery'" [min]="1"></app-form-numeric>
                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'">{{ repeatUnit }}</app-content>
                      </div>
                    </div>
                  </div>
      
                  <!-- Daily Repeat Section-->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'daily'">
                    <!-- Repeat Days End-->
                    <div class="col-6 col-md-3 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatEndType'" [dataSource]="repeatEndOptions" [placeholder]="'SELECT' | translate" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                      <div>&nbsp;</div>
                      <!-- Date Picker: show only if 'until' -->
                      <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                        <app-form-date
                            [fG]="calendarEventForm"
                            [fCN]="'repeatDaysUntil'"
                            [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                          ></app-form-date>
                      </div>
                      <!-- Numeric Input: show only if 'count' -->
                      <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                        <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                      </div>
                    </div>
                  </div>
      
                  <!-- Weekly Repeat Section -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'weekly'">
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATON' | translate"></app-form-label>
      
                      <div class="d-flex flex-wrap gap-2">
                        @for(day of weekdayOptions; track $index) {
                          <button
                            type="button"
                            class="e-round e-lib e-btn e-control"
                            [class.e-active]="!calendarEventForm.get('repeatOn')?.value?.includes(day.value)"
                            [class.e-primary]="calendarEventForm.get('repeatOn')?.value?.includes(day.value)"
                            (click)="toggleRepeatDay(day.value)"
                          >
                            {{ day.label }}
                          </button>
                        }
                      </div>
                    </div>
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                  <!-- Monthly repeat -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'monthly'">
                    <!-- Repeat On Section -->
                    <div class="col-12 col-md-6 mb-3">
                      <app-form-label [label]="'CALEVENTREPEATON' | translate"></app-form-label>
      
                      <!-- Day of Month Option -->
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [name]="'monthlyRepeatMode-monthly'" [value]="true" [placeholder]="'DAY' | translate" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-numeric
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyRepeatDay'"
                        ></app-form-numeric>
                      </div>
      
                      <!-- Ordinal Weekday Option -->
                      <div class="d-flex align-items-center gap-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [name]="'monthlyRepeatMode-monthly'" [value]="false" [placeholder]="'&nbsp;'" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyOrdinal'"
                          [dataSource]="ordinalOptions"
                        ></app-form-dropdown>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyWeekday'"
                          [dataSource]="weekdayOptionsLong"
                        ></app-form-dropdown>
                      </div>
                    </div>
      
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
                  <!-- Yearly repeat -->
                  <div class="row" [class.d-none]="calendarEventForm.get('repeatType')?.value !== 'yearly'">
                    <div class="col-12 col-md-6">
                      <app-form-label [label]="'CALEVENTREPEATS' | translate"></app-form-label>
                      <app-form-dropdown [fG]="calendarEventForm" [fCN]="'repeatMonth'" [dataSource]="monthOptions" [cssClass]="'me-2'"></app-form-dropdown>
                    </div>
                    <!-- End Type + Conditional Field -->
                    <div class="col-12 col-md-6">
                      <div class="row">
                        <div class="col-6 col-md-6 mb-3">
                            <app-form-label [label]="'CALEVENTREPEATEND' | translate"></app-form-label>
                            <app-form-dropdown
                              [fG]="calendarEventForm"
                              [fCN]="'repeatEndType'"
                              [dataSource]="repeatEndOptions"
                              [placeholder]="'SELECT' | translate"
                            ></app-form-dropdown>
                        </div>
                        <div class="col-6 col-md-6 mb-3">
                          <div>&nbsp;</div>
                          <!-- Repeat Until Date -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'until'">
                            <app-form-date
                              [fG]="calendarEventForm"
                              [fCN]="'repeatDaysUntil'"
                              [placeholder]="'CALEVENSELECTSTARTDATE' | translate"
                            ></app-form-date>
                          </div>
      
                          <!-- Repeat Count -->
                          <div [class.d-none]="calendarEventForm.get('repeatEndType')?.value !== 'count'">
                            <app-form-numeric [fG]="calendarEventForm" [fCN]="'repeatDaysCount'"></app-form-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <!-- Repeat On Section -->
                    <div class="col-12 col-md-6">
                      <!-- Day of Month Option -->
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [name]="'monthlyRepeatMode-yearly'" [value]="true" [placeholder]="'DAY' | translate" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-numeric
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyRepeatDay'"
                        ></app-form-numeric>
                      </div>
      
                      <!-- Ordinal Weekday Option -->
                      <div class="d-flex align-items-center gap-2">
                        <app-form-radio [fG]="calendarEventForm" [fCN]="'monthlyRepeatMode'" [name]="'monthlyRepeatMode-yearly'" [value]="false" [placeholder]="'&nbsp;'" [cssClass]="'e-normal'"></app-form-radio>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyOrdinal'"
                          [dataSource]="ordinalOptions"
                        ></app-form-dropdown>
      
                        <app-form-dropdown
                          [fG]="calendarEventForm"
                          [fCN]="'monthlyWeekday'"
                          [dataSource]="weekdayOptionsLong"
                        ></app-form-dropdown>
                      </div>
                    </div>
                  </div>
                }

                @if (recurrenceValidation.status === 'pending') {
                  <app-content [fontColor]="'text-muted'" [fontSize]="'fs-small'" [class]="'d-block mt-2'">
                    {{ 'LOADING' | translate }}
                  </app-content>
                }

                @if (recurrenceValidation.status === 'error' && getRecurrenceValidationMessage()) {
                  <div class="mt-2">
                    <app-error [message]="getRecurrenceValidationMessage()"></app-error>
                  </div>
                }
              }
              @case('guests') {
                @if (canInviteAllUsers()) {
                  <div class="d-flex flex-row align-items-center gap-3 mb-3">
                    <app-form-checkbox
                      [label]="'INVITEALLUSERS' | translate"
                      [checked]="participantsAllUsers"
                      (checkedChange)="onParticipantsAllUsersChange($event)"
                    ></app-form-checkbox>

                    @if (participantsAllUsers) {
                      <app-form-checkbox
                        [label]="'NOTIFYALLUESRS' | translate"
                        [checked]="false"
                        (checkedChange)="onParticipantsNotifyAllUsersChange($event)"
                      ></app-form-checkbox>
                    }
                  </div>
                }

                <app-form-user-group-mail 
                  [allowEmails]="selectedCalendarConfig()?.allow_external_users ?? false" 
                  [allowPush]="true" 
                  [defaultPushState]="false"
                  [pushUserIDs]="pushUserIDs"
                  [pushGroupIDs]="pushGroupIDs"
                  [mails]="participantsMails"
                  [can]="'calendar'"
                  [allowGroupsToResolve]="true"
                  [readonly]="participantsAllUsers"
                  [externalEmailsOnly]="participantsAllUsers"
                  [(user)]="participantsUserIDs" 
                  [(groups)]="participantsGroupIDs" 
                  (userChange)="onParticipantsChange()" 
                  (groupsChange)="onParticipantsChange()" 
                  (mailsChange)="participantsMails = $event; onParticipantsChange()" 
                  (pushUserIDsChange)="pushUserIDs = $event; onParticipantsChange()" 
                  (pushGroupIDsChange)="pushGroupIDs = $event; onParticipantsChange()"
                  >
                </app-form-user-group-mail>
              }
              @case('resources') {
                @if (isSelectedCalendarInventoryLoading) {
                  <div class="py-3">
                    <app-content [fontColor]="'text-muted'">{{ 'LOADING' | translate }}</app-content>
                  </div>
                } @else if (availableInventories().length === 0) {
                  <div class="py-3">
                    <app-content [fontColor]="'text-muted'">{{ 'CALNORESOURCESAVAILABLE' | translate}}</app-content>
                  </div>
                } @else {
                  <div class="d-flex flex-column gap-3">
                    <div>
                      <app-form-label [label]="'CALEVENTRESOURCES' | translate"></app-form-label>
                      <app-form-multi-select
                        [fG]="inventoryForm"
                        [fCN]="'selectedResourceIds'"
                        [dataSource]="selectedInventoryOptions"
                        [mapping]="{text: 'name', value: 'id'}"
                        [mode]="'CheckBox'"
                        [showSelectAll]="false"
                        [placeholder]="'SELECT' | translate"
                      ></app-form-multi-select>
                    </div>

                    @for (inventory of getSelectedInventoriesForDisplay(); track inventory.id) {
                      <div class="card">
                        <div class="card-body">
                          <div class="row g-3 align-items-start">
                            <div class="col-12 col-md-8">
                              <app-content [fontDecoration]="'fw-semibold'" [fontSize]="'fs-normal'" [class]="'d-block'">
                                {{ inventory.name }}
                              </app-content>

                              @if (shouldShowInventoryCapacity(inventory)) {
                                <app-content [fontColor]="'text-primary'" [fontSize]="'fs-small'" [class]="'d-block mt-1'">
                                  {{ 'RESOURCECAPACITY' | translate }}: {{ getEffectiveInventoryCapacity(inventory) }} ({{ getInventoryCapacityModeLabel(inventory) }})
                                </app-content>
                              }

                              @if (shouldShowInventoryQuantity(inventory)) {
                                <app-content [fontColor]="(inventory.conflict_mode === 'exclusive' ? 'text-danger' : 'text-warning')" [fontSize]="'fs-small'" [class]="'d-block mt-1'">
                                  {{ 'RESOURCEQUANTITY' | translate }}: {{ getInventoryAvailableQuantity(inventory) }} ({{ getInventoryQuantityModeLabel(inventory) }})
                                </app-content>
                              } @else {
                                <app-content [fontColor]="'text-success'" [fontSize]="'fs-small'" [class]="'d-block mt-1'">
                                  {{ 'RESOURCEQUANTITY' | translate }}: ({{ getInventoryQuantityModeLabel(inventory) }})
                                </app-content>
                              }

                              @if (inventory.description) {
                                <app-content [fontColor]="'text-muted'" [fontSize]="'fs-small'" [class]="'d-block mt-1'">
                                  {{ inventory.description }}
                                </app-content>
                              }
                            </div>

                            <div class="col-12 col-md-4 d-flex flex-column gap-3">
                              @if (shouldShowInventoryQuantity(inventory)) {
                                <div>
                                  <app-form-label [label]="'RESOURCEQUANTITY' | translate"  [class]="'fs-verysmall text-secondary'"></app-form-label>
                                  @if (getInventoryQuantityMaximum(inventory); as inventoryQuantityMaximum) {
                                    <app-form-numeric
                                      [fG]="inventoryForm"
                                      [fCN]="'inventory_quantity_' + inventory.id"
                                      [min]="1"
                                      [max]="inventoryQuantityMaximum"
                                    ></app-form-numeric>
                                  } @else {
                                    <app-form-numeric
                                      [fG]="inventoryForm"
                                      [fCN]="'inventory_quantity_' + inventory.id"
                                      [min]="1"
                                    ></app-form-numeric>
                                  }
                                </div>
                              }
                            </div>
                          </div>

                          @if (getInventoryItemValidationMessage(inventory.id); as inventoryValidationMessage) {
                            <div class="mt-3">
                              @if (shouldShowInventoryItemValidationAsError(inventory.id)) {
                                <app-error [message]="inventoryValidationMessage"></app-error>
                              } @else {
                                <app-warning [message]="inventoryValidationMessage"></app-warning>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }

                    @if (getSelectedInventoriesForDisplay().length > 0 && calculatedEventCapacity !== null) {
                      <div class="card">
                        <div class="card-body">
                          <app-form-label [label]="'RESOURCECAPACITY' | translate"></app-form-label>
                          <app-form-numeric
                            [fG]="calendarEventForm"
                            [fCN]="'maxParticipants'"
                            [min]="0"
                          ></app-form-numeric>
                        </div>
                      </div>
                    }

                    @if (inventoryValidation.status === 'pending') {
                      <app-content [fontColor]="'text-muted'" [fontSize]="'fs-small'" [class]="'d-block'">
                        {{ 'LOADING' | translate }}
                      </app-content>
                    }

                  </div>
                }
              }
              @case('settings') {
                  <div class="card-body d-flex flex-column gap-3">
                    <app-form-checkbox
                      [fCN]="'creatorNotifications'"
                      [fG]="calendarEventForm"
                      [checked]="!!calendarEventForm.get('creatorNotifications')?.value"
                      [cssClass]="'pb-1 lh-base'"
                      [labelPosition]="'After'"
                      [label]="'CALNOTIFYCREATORABOUTEVENT' | translate"
                    ></app-form-checkbox>
                  </div>
              }
            }
          </form>
        </div>

        <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
          @if(activeStep > 0){
            <app-form-button
              [text]="'PREV' | translate"
              (click)="handleStepChange(activeStep - 1)" 
              [cssClass]="'e-outline w-20'">
            </app-form-button>
          }
          @if(activeStep < steps.length - 1){
            <app-form-button 
              [text]="'NEXT' | translate" 
              [disabled]="!canAdvanceFromActiveStep()"
              (click)="handleStepChange(activeStep + 1)" 
              [cssClass]="'e-secondary ms-auto w-20'">
            </app-form-button>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-md-none d-flex gap-2 p-2">
      <div class="flex-shrink-0">
        @if(activeStep > 0){
          <app-form-button 
            [text]="'PREV' | translate" 
            (click)="handleStepChange(activeStep - 1)" 
            [cssClass]="'e-outline w-100 mx-1'">
          </app-form-button>
        } @else {
          <!-- Dummy button to keep the space for the flex container -->
          <app-form-button 
            [text]="'PREV' | translate" 
            [cssClass]="'e-outline invisible w-100 mx-1'">
          </app-form-button>
        }
      </div>
      <div class="flex-grow-1 d-flex justify-content-center">
        <app-form-button [text]="'SAVE' | translate" [disabled]="calendarEventForm.invalid || inventoryForm.invalid || !canSaveCurrentEvent()" (click)="save()" [cssClass]="'e-primary w-90'"></app-form-button>
      </div>
      <div class="flex-shrink-0">
        @if(activeStep < steps.length - 1){
          <app-form-button 
            [text]="'NEXT' | translate" 
            [disabled]="!canAdvanceFromActiveStep()"
            (click)="handleStepChange(activeStep + 1)" 
            [cssClass]="'e-secondary w-100 mx-1'">
          </app-form-button>
        }
        @if(activeStep === steps.length - 1) {
          <!-- Dummy button to keep the space for the flex container -->
          <app-form-button 
            [text]="'NEXT' | translate" 
            [cssClass]="'e-secondary invisible w-100 mx-1'">
          </app-form-button>
        }

      </div>
    </div>
  </ng-template>
</ejs-dialog>

<!-- small dialog which popups up in case if the user is editing the master event itself to ask the user if he wants to align all existing overwrites of occurances to the new master or leave them as they are-->
<ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='visibleQuickDialog' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-headline [title]="'CALUPDATEMASTER' | translate" [type]="'h5'"></app-headline>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column p-3">
      <div class="mb-3">
        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'CALUPDATEMASTERQUESTION' | translate }}</app-content>
      </div>
      
      <div class="d-flex flex-column gap-2">
        <!-- Check All -->
        <div class="mb-2">
          <ejs-checkbox
            name="allAdaptChecked"
            [(ngModel)]="allAdaptChecked"
            [labelPosition]="'After'"
            [label]="'CALADAPTALL' | translate"
            [cssClass]="'fw-bold'"
          ></ejs-checkbox>
        </div>

        <div class="ms-3 d-flex flex-column gap-2">
          <!-- Details Section -->
          <ejs-checkbox
            name="adaptDetails"
            [(ngModel)]="adaptDetails"
            [disabled]="!section0Edited"
            [labelPosition]="'After'"
            [label]="steps[0].title"
          ></ejs-checkbox>

          <!-- Date/Location Section -->
          <ejs-checkbox
            name="adaptDateLocation"
            [(ngModel)]="adaptDateLocation"
            [disabled]="!section1Edited"
            [labelPosition]="'After'"
            [label]="steps[1].title"
          ></ejs-checkbox>

          <!-- Guests Section -->
          <ejs-checkbox
            name="adaptGuests"
            [(ngModel)]="adaptGuests"
            [disabled]="!section2Edited"
            [labelPosition]="'After'"
            [label]="steps[2].title"
          ></ejs-checkbox>

          @if (steps.some(step => step.id === 'resources')) {
            <ejs-checkbox
              name="adaptInventories"
              [(ngModel)]="adaptInventories"
              [disabled]="!section3Edited"
              [labelPosition]="'After'"
              [label]="resourcesStepTitle"
            ></ejs-checkbox>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-flex align-items-center gap-2 w-100 p-2">
      <app-form-button
        [text]="'SAVE' | translate"
        (click)="saveQuickDialog()"
        [cssClass]="'e-primary'"
      ></app-form-button>      

      <app-form-button
        [text]="'CANCEL' | translate"
        (click)="cancelQuickDialog()"
        [cssClass]="'e-outline mx-1'"
      ></app-form-button>
    </div>
  </ng-template>
</ejs-dialog>
